import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import NameAndStatus from '@blade-sxp/task-management/components/name-status.vue';
import DeviceDarwer from '@blade-sxp/task-management/components/deviceDarwer/index.vue';
import OpenTime from '@blade-sxp/task-management/components/open-time.vue';
import ValidTime from '@blade-sxp/task-management/components/valid-time1.vue';
import AlarmLevel from '@blade-sxp/task-management/components/alarm-level.vue';
import FrequencyAndThreshold from '@blade-sxp/task-management/components/frequency-threshold.vue';
import ButtonBox from '@blade-sxp/task-management/components/button-box.vue';
import { postTask, updateTask, getTaskDetail } from '@blade-sxp/task-management/api/creat-task/index';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { isEmpty, cloneDeep } from 'lodash';
import { plotMap } from '@blade-sxp/task-management/components/deviceDarwer/plotConfig';
import SingleConfidence from '@blade-sxp/task-management/components/single-confidence.vue';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
const Service = {
    postTask,
    updateTask,
    getTaskDetail,
};
let TrafficIllegalParking = class TrafficIllegalParking extends Vue {
    loading = false;
    name = '';
    status = 'ENABLE';
    isDetail = false;
    taskType = '';
    isReady = false;
    type = 'add';
    id = '';
    disableRight = false;
    // IllegalParkingTime: string = '600';
    isError = false;
    titleList = {
        leftTitle: this.$t('taskType'),
        rightTitle: this.$t('confidence'),
    };
    level = 'CRITICAL';
    alertInterval = 600;
    effectivePeriod = 'PERMANENT';
    effectiveDates = {
        start: '',
        end: '',
    };
    dayOfWeeks = [];
    effectiveTimes = [{ start: '', end: '' }];
    // trafficIllegalStopConfidence: ConfidenceType = {
    //   value: '66',
    //   countUnitEnum: 'PERCENT',
    // };
    confidenceValue = '66';
    remark = '';
    get formData() {
        const { name, effectivePeriod, effectiveDates, effectiveTimes, dayOfWeeks, isReady, alertInterval, confidenceValue,
        // IllegalParkingTime,
         } = this;
        return {
            name,
            effectivePeriod,
            effectiveDates,
            effectiveTimes,
            dayOfWeeks,
            isReady,
            alertInterval,
            // IllegalParkingTime,
            confidenceValue,
        };
    }
    async validForm() {
        if (this.isDetail) {
            return;
        }
        if (!this.isReady) {
            this.disableRight = true;
            return;
        }
        for (let i = 1; i <= 5; i++) {
            if (this.$refs['ruleForm' + i]) {
                let res = await this.$refs['ruleForm' + i].isValidate();
                if (!res) {
                    this.disableRight = true;
                    return;
                }
            }
        }
        this.disableRight = false;
    }
    init() {
        const { type, id, taskType } = this.$route.query;
        this.type = type;
        this.taskType = taskType;
        this.id = id;
        this.isDetail = type === 'detail';
        if (this.type === 'add') {
            this.loading = false;
        }
        else {
            if (this.isDetail) {
                this.disableRight = false;
            }
            this.getData();
        }
    }
    submit() {
        let taskStatus = '';
        if (this.type === 'update') {
            if (this.isError && this.status === 'DISABLE') {
                taskStatus = 'DISABLE';
            }
            else if (this.isError && this.status === 'ENABLE') {
                taskStatus = 'ERROR';
            }
            else {
                taskStatus = this.status;
            }
        }
        else {
            taskStatus = this.status;
        }
        const effectiveTimes = [];
        if (this.effectivePeriod === 'CUSTOMIZE') {
            this.effectiveTimes.forEach((item) => {
                effectiveTimes.push({ start: item.effectiveTimes[0], end: item.effectiveTimes[1] });
            });
        }
        // const countUnitEnum = 'PERCENT';
        // this.trafficIllegalStopConfidence = {
        //   countUnitEnum: countUnitEnum,
        //   value: this.confidenceValue,
        // };
        const params = {
            taskName: this.name,
            taskStatus: taskStatus,
            taskType: this.taskType,
            remark: this.remark,
            alarmConfig: {
                enable: true,
                notifyConfig: {
                    enabledAlarmLevels: [this.level],
                    frequency: {
                        unit: 'SECOND',
                        value: this.alertInterval,
                    },
                },
                thresholdConfigs: [
                    {
                        effectivePeriod: this.effectivePeriod,
                        dayOfWeeks: this.dayOfWeeks,
                        effectiveTimes: this.effectivePeriod === 'PERMANENT' ? [] : effectiveTimes,
                        effectiveDates: this.effectivePeriod === 'PERMANENT' ? [] : [this.effectiveDates],
                        noneMotorVehicleDetectThreshold: {
                            vehicleDetectConfidence: {
                                countUnitEnum: 'PERCENT',
                                value: Number(this.confidenceValue),
                            },
                        },
                    },
                ],
            },
            deviceTaskConfigs: this.fromDataDeviceConfig(),
        };
        if (this.type === 'add' || this.type === 'copy') {
            Service.postTask(params).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
        else {
            Service.updateTask({ taskId: this.id, ...params }).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    fromDataDeviceConfig() {
        const config = [];
        let device = DeviceIdDataModule.deviceIdRequestParams;
        let requestMap = new Map();
        requestMap = cloneDeep(device);
        const incidentType = plotMap.get(this.taskType).incidentType;
        if (!isEmpty(requestMap) && !isEmpty(incidentType)) {
            requestMap.forEach((item) => {
                const { zoneId, deviceId, titleList } = item;
                let directionRoiMappings = [];
                if (!isEmpty(titleList)) {
                    titleList.forEach((item) => {
                        if (item.type === 'ROI') {
                            item.data.forEach((item) => {
                                const { vertices, id } = item;
                                vertices.shift();
                                directionRoiMappings.push({
                                    directions: [],
                                    rawRoi: {
                                        vertices,
                                        id: this.taskId(),
                                        name: id,
                                    },
                                    length: '',
                                    twinRoi: {},
                                });
                            });
                        }
                    });
                }
                let data = {
                    zoneId,
                    deviceId,
                    incidentType,
                    roiData: JSON.stringify(device.get(deviceId)),
                    noneMotorVehicleDetectConfig: {
                        directionRoiMappings,
                        noneMotorVehicleDetectThreshold: {
                            vehicleDetectConfidence: {
                                countUnitEnum: 'PERCENT',
                                value: this.confidenceValue,
                            },
                        },
                    },
                };
                config.push(data);
            });
        }
        return config;
    }
    getData() {
        this.loading = true;
        Service.getTaskDetail(Number(this.id))
            .then(({ name, status, remark, alarmConfig: { thresholdConfigs, notifyConfig }, deviceTaskConfigs }) => {
            this.name = name;
            this.remark = remark;
            if (status === 'ERROR') {
                this.isError = true;
                this.status = 'ENABLE';
            }
            else {
                this.status = status;
            }
            if (thresholdConfigs) {
                const { dayOfWeeks, effectiveDates, effectivePeriod, effectiveTimes, noneMotorVehicleDetectThreshold } = thresholdConfigs[0];
                this.dayOfWeeks = dayOfWeeks;
                this.effectivePeriod = effectivePeriod;
                if (this.effectivePeriod !== 'PERMANENT') {
                    this.effectiveDates = effectiveDates[0];
                    this.effectiveTimes = effectiveTimes.map((item) => {
                        return { ...item, effectiveTimes: [item.start, item.end] };
                    });
                }
                this.confidenceValue = noneMotorVehicleDetectThreshold?.vehicleDetectConfidence?.value;
                this.alertInterval = notifyConfig?.frequency?.value;
                this.level = notifyConfig?.enabledAlarmLevels[0];
                if (!isEmpty(deviceTaskConfigs)) {
                    deviceTaskConfigs.forEach((item) => {
                        const roiData = item.roiData;
                        if (!isEmpty(roiData)) {
                            const analysis = JSON.parse(roiData);
                            DeviceIdDataModule.deviceIdRequestParams.set(analysis.id, analysis);
                        }
                    });
                }
            }
        })
            .finally(() => {
            this.loading = false;
        });
    }
    clickRightButton() {
        if (this.type === 'detail') {
            const url = this.$route.path;
            this.$router.push({ path: url, query: { type: 'update', taskType: this.taskType, id: this.id } });
            this.$route.meta.title = this.$route.meta.title.replace('look', 'edit');
        }
        else {
            this.submit();
        }
    }
    cancel() {
        if (this.type === 'detail') {
            this.$router.push('/tasklist');
        }
        else {
            this.$confirm(`${this.$t('cancelSubmitTip')}`, `${this.$t('tip')}`, {
                confirmButtonText: `${this.$t('confirm')}`,
                cancelButtonText: `${this.$t('cancel')}`,
                cancelButtonClass: 'cancel-roi-tip',
                confirmButtonClass: 'confirm-roi-tip',
                type: 'warning',
            })
                .then(() => {
                this.$router.push('/tasklist');
            })
                .catch(() => { });
        }
    }
};
__decorate([
    Watch('formData', { deep: true, immediate: true })
], TrafficIllegalParking.prototype, "validForm", null);
__decorate([
    Watch('$route', { immediate: true, deep: true })
], TrafficIllegalParking.prototype, "init", null);
TrafficIllegalParking = __decorate([
    Component({
        name: 'TrafficIllegalParking',
        components: {
            'name-and-status': NameAndStatus,
            'device-darwer': DeviceDarwer,
            'open-time': OpenTime,
            'valid-time': ValidTime,
            'alarm-level': AlarmLevel,
            'frequency-and-threshold': FrequencyAndThreshold,
            'button-box': ButtonBox,
            'single-confidence': SingleConfidence,
            'task-note': TaskNote,
        },
        i18n: {
            messages: {
                en: {
                    trafficIllegalStopConfidence: 'Illegal Parking Detection',
                    taskType: 'Type',
                    confidence: 'Confidence',
                    IllegalParkingTime: 'Illegal Parking Time',
                    alert: 'Alert Notification',
                    cancelSubmitTip: 'Data will not be saved and exit. Are you sure to exit?',
                    tip: 'Tips',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                },
                zh: {
                    trafficIllegalStopConfidence: '违停',
                    taskType: '类型',
                    confidence: '置信度',
                    IllegalParkingTime: '违停时间阈值',
                    alert: '告警通知',
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                },
            },
        },
    })
], TrafficIllegalParking);
export default TrafficIllegalParking;
